import React from 'react';
import { useLocation } from 'react-router-dom';
import ModuleRenderer from '../../components/H5Module/ModuleRenderer';
import styles from './index.module.scss';

const H5Preview = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const modulesData = searchParams.get('data');
    let modules = null;

    try {
        modules = modulesData ? JSON.parse((modulesData)) : null;
    } catch (error) {
        console.error('解析预览数据失败:', error);
        return <div>预览数据格式错误，请检查参数是否正确</div>;
    }

    if (!modules) {
        return <div>预览参数错误</div>;
    }

    return (
        <div className={styles.previewContainer}>
            <div className={styles.previewFrame}>
                {modules.map((module) => (
                    <ModuleRenderer
                        key={module.id}
                        type={module.type}
                        data={module.data}
                        style={module.style}
                        moduleId={module.id}
                        preview={true}
                    />
                ))}
            </div>
        </div>
    );
};

export default H5Preview;